export const blockIconsEditorFormatQuote = (
	<span className='material-symbols-outlined'>format_quote</span>
);
